import gql from 'graphql-tag';

export const albumMembershipGroupExists = gql`
  query albumMembershipGroupExists(
    $id: RecordID!
    $root_groups_only: Boolean
    $include_matched_photos_only: Boolean
  ) {
    albumMembershipGroup(
      id: $id
      root_groups_only: $root_groups_only
      include_matched_photos_only: $include_matched_photos_only
    ) {
      id
      display_name
    }
  }
`;
